import {
  Component,
  ElementRef,
  inject,
  input,
  viewChild,
  ViewEncapsulation,
} from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatDialog } from '@angular/material/dialog';
import { NgxGaugeModule } from 'ngx-gauge';
import * as domtoimage from 'dom-to-image';
import { NgClass } from '@angular/common';
import * as XLSX from 'xlsx';

import { GaugeValueModalComponent } from './gauge-value-modal/gauge-value-modal.component';
import { GaugeValueKPI } from '../../types';

@Component({
  selector: 'app-gauge-value',
  templateUrl: './gauge-value.component.html',
  styleUrl: './gauge-value.component.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [
    MatProgressSpinnerModule,
    MatTooltipModule,
    NgxGaugeModule,
    SharedModule,
    NgClass,
  ],
})
export class GaugeValueComponent {
  readonly modalContent = viewChild<ElementRef>('modalContent');

  readonly data = input.required<GaugeValueKPI>();

  readonly loading = input(false);

  private readonly matDialog = inject(MatDialog);

  public downloadImage(): void {
    const contentElement = this.modalContent()?.nativeElement as
      | HTMLElement
      | undefined;

    if (contentElement !== undefined && contentElement !== null) {
      const options = {
        width: contentElement.offsetWidth,
        height: contentElement.offsetHeight,
        scale: 1.5,
        style: {
          transform: 'scale(1)',
          transformOrigin: 'top center',
        },
      };

      domtoimage
        .toPng(contentElement, options)
        .then((dataUrl: string) => {
          const link = document.createElement('a');
          link.href = dataUrl;
          link.download = 'component-image.png';
          link.click();
        })
        .catch((error) => {
          console.error('Error', error);
        });
    }
  }

  public openModal(): void {
    this.matDialog.open<GaugeValueModalComponent, GaugeValueKPI>(
      GaugeValueModalComponent,
      {
        width: 'calc(100vw - 1rem)',
        hasBackdrop: true,
        data: this.data(),
      },
    );
  }

  public downloadXlsx(): void {
    const d = this.data();
    const thresholds = [0, 25, 50, 75, 100];

    const rows: Array<[string, number]> = [
      ['Current Value', d.value],
      ['Max Value', d.maxValue],
      ...thresholds.map((pct): [string, number] => [
        `Threshold ${pct}%`,
        d.maxValue * (pct / 100),
      ]),
    ];

    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet([
      ['Metric', 'Value'],
      ...rows,
    ]);
    const wb: XLSX.WorkBook = XLSX.utils.book_new();

    XLSX.utils.book_append_sheet(wb, ws, 'Gauge Data');
    XLSX.writeFile(wb, 'gauge-data.xlsx');
  }
}
